import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import DropDownMenu from '../../shared/components/DropDownMenu';
import { AccountSelectDto } from '../AccountSelect/models';
import AccountSwitcherMenuItem from './AccountSwitcherMenuItem';
import AccountSwitcherSelectedMenuItem from './AccountSwitcherSelectedMenuItem';

export default function AccountSwitcher({
  accountName,
  className,
  accountList,
  currentAccountId,
}: any) {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef: any = useRef(undefined);
  const menuContainerRef: any = useRef(undefined);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      // Bypass when clicked on the menu container
      if (
        menuContainerRef?.current &&
        menuContainerRef.current.contains(event.target)
      ) {
        return;
      }

      if (menuRef?.current && !menuRef?.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  const handleMenuClick = (e: any) => {
    // Bypass when clicked inside the dropdown menu
    if (menuRef?.current && menuRef?.current.contains(e.target)) {
      return;
    }

    setShowMenu(!showMenu);
  };

  return (
    <div
      className={`d-flex cursor-pointer ${className ?? ''}`}
      onClick={handleMenuClick}
      tabIndex={0}
      role="radio"
      aria-checked={showMenu}
      ref={menuContainerRef}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleMenuClick(e);
        }
      }}
    >
      <div className="d-sm-flex flex-column justify-content-end small me-2 d-none">
        <div className="organization-selector-control-text-gray-600">
          Viewing as
        </div>
        <div className="accent-link">{accountName}</div>
      </div>
      <div className="text-primary small d-sm-none me-2">Switch Account</div>
      <DropDownMenu
        showMenu={showMenu}
        menuRef={menuRef}
        menuClassName="account-switcher-menu"
      >
        <div className="dsm bg-white rounded shadow overflow-hidden">
          <div className="org-selector-menu pt-4">
            <h4 className="text-center text-nowrap fw-bold px-3">
              Switch Partner Account
            </h4>

            {accountList.accounts.totalItemCount > 3 ? (
              <div className="border-botoom px-3 pb-4">
                <Link className="accent-link" to="/admin/select-account">
                  Select from {accountList.accounts.totalItemCount} available
                  accounts
                </Link>
              </div>
            ) : (
              <>
                {accountList.accounts.items
                  .filter(
                    (x: AccountSelectDto) => x.accountId === currentAccountId,
                  )
                  .map((account: AccountSelectDto) => (
                    <AccountSwitcherSelectedMenuItem
                      key={account.accountId}
                      account={account}
                    />
                  ))}

                {accountList.accounts.items
                  .filter(
                    (x: AccountSelectDto) => x.accountId !== currentAccountId,
                  )
                  .map((account: AccountSelectDto) => (
                    <AccountSwitcherMenuItem
                      key={account.accountId}
                      account={account}
                    />
                  ))}
              </>
            )}
          </div>
        </div>
      </DropDownMenu>
    </div>
  );
}
